import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ActionIconType = 'edit' | 'delete';

@Component({
  selector: 'app-action-icon',
  templateUrl: './action-icon.component.html',
  styleUrls: ['./action-icon.component.scss']
})
export class ActionIconComponent {
  @Input() action: ActionIconType = 'edit';
  @Input() label = '';
  @Input() size: 'sm' | 'md' = 'sm';
  @Input() disabled = false;
  @Output() actionClick = new EventEmitter<Event>();

  get ariaLabel(): string {
    if (this.label) return this.label;
    return this.action === 'edit' ? 'Edit' : 'Delete';
  }

  onClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.actionClick.emit(event);
    }
  }
}
